import { useEffect, useState } from "react";
import { AdminCardStyles } from "./AdminCard.style";
import { Table } from "../../atoms";
import { structureData } from "../../../utils/FormatData";
import { useDispatch, useSelector } from "react-redux";
import { getDeviceSentMessages } from "../../../Redux/Zte/Device/DeviceActions";
import SortFilterMessages from "../../molecules/SortFilterMessages/SortFilterMessages";
import InformationModal from "../InformationModal";

const SentMessagesTable = () => {
  const headers = ["Date", "Sender", "Device", "Success"];
  const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState(
    new Date(new Date().getFullYear(), 0, 1).toJSON()
  );
  const [endDate, setEndDate] = useState(new Date().toJSON());
  const [sortValue, setSortvalue] = useState("");
  const [sortParams, setSortParams] = useState(0);
  const [sortOrder, setSortOrder] = useState(0);
  const [message, setMessage] = useState("");
  const [username, setUsername] = useState("");
  const [deviceName, setDeviceName] = useState("");
  const [open, setOpen] = useState();
  const [selectedData, setSelectedData] = useState();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getDeviceSentMessages(
        currentPage,
        startDate,
        endDate,
        sortOrder,
        sortParams,
        message,
        username,
        deviceName
      )
    );
    // eslint-disable-next-line
  }, [dispatch, currentPage]);

  const handleApply = () => {
    dispatch(
      getDeviceSentMessages(
        currentPage,
        startDate,
        endDate,
        sortOrder,
        sortParams,
        message,
        username,
        deviceName
      )
    );
  };
  const handleRowClick = (id) => {
    setOpen(true);
    setSelectedData(id);
  };

  const { sentMessages, fetchingSentMessages } = useSelector(
    (state) => state.devices
  );

  return (
    <AdminCardStyles>
      <div>
        <SortFilterMessages
          sortValue={sortValue}
          setSortvalue={setSortvalue}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          setSortParams={setSortParams}
          setSortOrder={setSortOrder}
          setMessage={setMessage}
          setUsername={setUsername}
          setDeviceName={setDeviceName}
          handleApply={handleApply}
        />
      </div>
      <div className="table-style">
        <Table
          headers={headers}
          data={structureData("sentMessages", sentMessages?.results)}
          loading={fetchingSentMessages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalCount={sentMessages?.totalCount}
          pageSize={10}
          type="info"
          handleRowClick={handleRowClick}
        />
      </div>
      <InformationModal
        open={open}
        setOpen={setOpen}
        data={selectedData}
        type="messages"
      />
    </AdminCardStyles>
  );
};

export default SentMessagesTable;
